import React, { useState } from "react";

export default function AgriInsuranceForm() {
  const [agree, setAgree] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    farmerName: "",
    farmSize: "",
    location: "",
    cropType: "",
    coverageType: "",
    insuranceAmount: "",
    premiumBudget: "",
    duration: "",
    remarks: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!agree) {
      alert("⚠️ You must agree to the Terms & Conditions before submitting.");
      return;
    }
    // console.log("Insurance Lead Submitted:", formData);
    alert("✅ Insurance request submitted! Our Agri Insurance Partner will contact you.");
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-black p-6">
      <form
        onSubmit={handleSubmit}
        className="bg-green-800 shadow-lg rounded-2xl p-6 w-full border border-green-200"
      >
        <h2 className="text-xl font-bold text-center text-yellow-200 mb-6">
          🌾 Agri Insurance: Protecting Farmers, Securing Futures
        </h2>
        <p className="text-white text-center mb-6 text-sm">
          Register your interest for agriculture insurance. Our partners will reach out with best coverage options.
        </p>

        {/* Farmer Details */}
        <label className="block mb-2 font-medium">Farmer Name</label>
        <input
          type="text"
          name="farmerName"
          value={formData.farmerName}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
          placeholder="Enter farmer's full name"
        />

        <label className="block mb-2 font-medium">Farm Size (in Acres)</label>
        <input
          type="number"
          name="farmSize"
          value={formData.farmSize}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
          placeholder="e.g., 5"
        />

        <label className="block mb-2 font-medium">Farm Location</label>
        <input
          type="text"
          name="location"
          value={formData.location}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
          placeholder="Village, District, State"
        />

        <label className="block mb-2 font-medium">Primary Crop Type</label>
        <input
          type="text"
          name="cropType"
          value={formData.cropType}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
          placeholder="Wheat, Rice, Sugarcane..."
        />

        {/* Insurance Details */}
        <label className="block mb-2 font-medium">Coverage Type</label>
        <select
          name="coverageType"
          value={formData.coverageType}
          onChange={handleChange}
          className="h-10 p-2 mb-4 border rounded-lg w-full"
        >
          <option value="">-- Select Coverage --</option>
          <option value="Crop Failure">Crop Failure</option>
          <option value="Weather Risk">Weather Risk</option>
          <option value="Pest & Disease">Pest & Disease</option>
          <option value="Multi-Peril">Multi-Peril Insurance</option>
        </select>

        <label className="block mb-2 font-medium">Insurance Amount (₹)</label>
        <input
          type="number"
          name="insuranceAmount"
          value={formData.insuranceAmount}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
          placeholder="e.g., 100000"
        />

        <label className="block mb-2 font-medium">Premium Budget (₹)</label>
        <input
          type="number"
          name="premiumBudget"
          value={formData.premiumBudget}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
          placeholder="e.g., 5000 per year"
        />

        <label className="block mb-2 font-medium">Coverage Duration</label>
        <select
          name="duration"
          value={formData.duration}
          onChange={handleChange}
          className="h-10 w-full p-2 mb-4 border rounded-lg"
        >
          <option value="">-- Select Duration --</option>
          <option value="6 Months">6 Months</option>
          <option value="12 Months">12 Months</option>
          <option value="24 Months">24 Months</option>
        </select>

        {/* Remarks */}
        <label className="block mb-2 font-medium">Additional Remarks</label>
        <textarea
          name="remarks"
          value={formData.remarks}
          onChange={handleChange}
          style={{ height: "120px" }}
          className="w-full p-2 mb-4 border rounded-lg text-sm"
          placeholder="Any special request or info..."
        />

        {/* Terms & Conditions */}
        <div className="flex items-center mb-4 text-sm text-gray-600">
          <input
            type="checkbox"
            checked={agree}
            onChange={(e) => setAgree(e.target.checked)}
            className="mr-2"
          />
          <button
            type="button"
            onClick={() => setShowModal(true)}
            className="text-blue-600 underline"
          >
            I agree to the Terms & Conditions
          </button>
        </div>

        {/* Submit */}
        <button
          type="submit"
          className="w-full bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg"
        >
          Submit Insurance Request
        </button>
      </form>

      {/* Terms Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-gray-600 rounded-2xl shadow-lg w-11/12 max-w-2xl p-6 overflow-y-auto max-h-[80vh]">
            <h2 className="text-xl font-bold mb-4 text-center text-yellow-200">
              🌿 Agri Insurance Terms & Conditions
            </h2>
            <div className="text-sm text-gray-700 space-y-3">
              <p>1. Insurance is provided by registered insurance companies.</p>
              <p>2. Farmers must provide valid KYC and land ownership/lease documents.</p>
              <p>3. Premium payments must be made as per policy terms.</p>
              <p>4. Claims are subject to verification and insurance company rules.</p>
              <p>5. AgriLink acts only as a digital facilitator between farmers and insurers.</p>
              <p>6. Data is confidential and shared only with authorized partners.</p>
              <p>7. Disputes fall under Indian jurisdiction (Mumbai courts).</p>
            </div>
            <div className="mt-6 flex justify-center">
              <button
                onClick={() => setShowModal(false)}
                className="bg-green-700 hover:bg-green-800 text-white px-4 py-2 rounded-lg"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
